import React, { FC } from "react";
import { /*CardMedia,*/ makeStyles } from "@material-ui/core";
import { intermediarioSelector } from "../store/intermediario/intermediario.selectors";
import { useSelector } from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  root: {
    maxHeight: 80,
    maxWidth: 155,
    [theme.breakpoints.down("xs")]: {
      maxHeight: 44,
      maxWidth: 107,
    },
  },
}));

export const IntermediarioLogo: FC = () => {
  const classes = useStyles();
  const intermediario = useSelector(intermediarioSelector);
  if (intermediario.loading) {
    return <CircularProgress />;
  } else if (!intermediario.data) {
    return null;
  } else {
    const { logo, ragioneSociale } = intermediario.data;
    return <img src={logo} alt={ragioneSociale} className={classes.root} />;
  }
};
